import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RegionState } from 'types';

export const initialState: RegionState = {
  loading: false,
  regionList: [],
  reset: false,
  filter: {
    manufacture: '',
    distributor: ''
  }
};

const slice = createSlice({
  name: 'Region',
  initialState,
  reducers: {
    setRegionList: (state, { payload }: PayloadAction<any>) => {
      state.loading = false;
      state.regionList = payload || [];
      state.reset = false;
    },
    reset: (state) => {
      state.reset = true;
    },
    setFilter: (state, { payload }: PayloadAction<any>) => {
      const filter = { ...payload };

      state.filter = { ...state.filter, ...filter };
    }
  }
});

export const { setRegionList, reset, setFilter } = slice.actions;

export default slice.reducer;
